import React, { Component } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import StarIcon from "@material-ui/icons/Star";
import AddIcon from "@material-ui/icons/Add";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarHalfIcon from "@material-ui/icons/StarHalf";
import moment from "moment";
import DocumentViewer from "../DocumentViewer";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Trans } from "react-i18next";
import LinkIcon from "@material-ui/icons/Link";
import axios from "../../AxiosClient";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Tooltip from "@material-ui/core/Tooltip";
import { mdiLightbulbOnOutline } from "@mdi/js";
import { connect } from "react-redux";
import Collapse from "@material-ui/core/Collapse";
import classnames from "classnames";
import ButtonBase from "@material-ui/core/ButtonBase";
import DocumentCategories from "../document/DocumentCategories";
import DisplayUser from "../user/DisplayUser";
import SearchResolution from "./SearchResolution";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import { withLastLocation } from "react-router-last-location";
import { withRouter } from "react-router-dom";
import PubSub from "pubsub-js";
import { PORTLET_LAYOUT_ADD } from "../../utils/Topics";

const styles = (theme) => ({
  heading: {
    padding: 10,
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "35%",
    flexShrink: 0,
  },
  // "@media(max-width: 1500px)": {
  //   heading: {
  //     wordBreak: "break-all",
  //   },
  // },
  secondaryHeading: {
    padding: 12,
    marginLeft: 50,
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  secondaryHeadingMobile: {
    padding: 10,
    // marginLeft: 50,
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  score: {
    padding: 12,
    marginLeft: "auto",
    whiteSpace: "nowrap",
  },
  card: {
    height: "100%",
  },
  addToList: {
    padding: 12,
    marginLeft: 10,
  },
  resolutionIcon: {
    marginRight: 12,
  },
  expansionPanel: {
    marginTop: 0,
    marginBottom: 0,
  },
  expansionPanelContent: {
    marginTop: 0,
    marginBottom: 0,
    alignItems: "center",
  },
  expansionPanelSummary: {
    marginTop: 0,
    marginBottom: 0,
  },
  wrapperDiv: {
    borderBottom: "1px solid rgb(222,222,222)",
    display: "flex",
  },
  expanded: {},
  focused: {},
  disabled: {},
  accordionRoot: {
    display: "flex",
    flex: 1,
    minHeight: 8 * 6,
    transition: theme.transitions.create(["min-height", "background-color"], {
      duration: theme.transitions.duration.shortest,
    }),
    padding: theme.spacing(0, 2),
    "&:hover:not($disabled)": {
      cursor: "pointer",
    },
    "&$expanded": {
      minHeight: 64,
    },
    "&$focused": {
      backgroundColor: theme.palette.action.focus,
    },
    "&$disabled": {
      opacity: theme.palette.action.disabledOpacity,
    },
  },
  expandIcon: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create(
      "transform",
      theme.transitions.create(["min-height", "background-color"], {
        duration: theme.transitions.duration.shortest,
      })
    ),
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&$expanded": {
      transform: "rotate(180deg)",
    },
  },
  centeredIcon: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
});

export class SearchResult extends Component {
  state = {
    menuAnchor: null,
    instance: new Date().getTime().toString(),
    newListDialogOpen: false,
    newListTitle: "",
    resolutionId: "",
    expanded: false,
    focused: false,
    // mounted: false,
  };
  componentDidMount() {
    if (Number(this.props.urlDocId) === this.props.result.documentId) {
      this.setState({ expanded: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    this.props.resolutions !== prevProps.resolutions &&
      this.props.resolutions.indexOf(this.state.resolutionId) < 0 &&
      this.setState({ resolutionId: "" });
  }

  getSecondaryInfo = () => {
    let info = this.props.secondaryInfo;
    if (!info || info.length === 0) {
      info = ["global_topic"];
    }
    return (
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        {info.map((setting, idx) => {
          switch (setting) {
            case "global_category_plural":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <DocumentCategories
                      chipsOnly
                      defaultValue={this.props.result.categories}
                    />
                  </Typography>
                </div>
              );
            case "live_draft_status":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="search_result_live_draft" />
                    {": "}
                    {this.props.result.isDraft ? (
                      <Trans i18nKey="global_draft" />
                    ) : (
                      <Trans i18nKey="global_live" />
                    )}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "global_author":
              return (
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="global_author" />
                    {": "}
                  </Typography>
                  {!!this.props.result.author ? (
                    <DisplayUser
                      noAvatar
                      userId={
                        this.props.result.author
                          ? this.props.result.author.userId
                          : ""
                      }
                      user={this.props.result.author}
                    />
                  ) : (
                    <Trans i18nKey="global_unknown" />
                  )}
                  <Typography style={{ marginRight: 10 }}>
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "global_like_plural":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="global_like_plural" />
                    {": "}
                    {this.props.result.likes && this.props.result.likes > 0
                      ? this.props.result.likes
                      : 0}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "global_view_plural":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="global_view_plural" />
                    {": "}
                    {this.props.result.views && this.props.result.views > 0
                      ? this.props.result.views
                      : 0}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "global_topic":
              return (
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="global_topic" />
                    {": "}
                  </Typography>
                  <DisplayLocation
                    type="TOPIC"
                    itemId={this.props.result.topicId}
                    topicId={this.props.result.topicId}
                    title={this.props.result.topic}
                  />
                  <Typography style={{ marginRight: 10 }}>
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "search_info_date_created":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="search_info_date_created" />
                    {": "}
                    {moment(this.props.result.createdDate).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "document_type":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="document_type" />
                    {": "}
                    {(() => {
                      let matching = this.props.documentTypes.filter(
                        (dt) =>
                          dt.documentTypeID == this.props.result.documentType
                      );
                      if (matching.length === 0) {
                        return "None";
                      }
                      return matching[0].name;
                    })()}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "document_url":
              return (
                <div>
                  <Typography
                    style={{
                      marginRight: 10,
                      maxWidth: 300,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <Trans i18nKey="document_url" />
                    {": "}
                    {this.props.result.url}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "global_knowledge_source":
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="global_knowledge_source" />
                    {": "}
                    {this.props.result.knowledgeSource}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
            case "search_info_date_modified":
            default:
              return (
                <div>
                  <Typography style={{ marginRight: 10 }}>
                    <Trans i18nKey="search_result_last_modified" />{" "}
                    {moment(this.props.result.lastModifiedDate).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                    {idx < info.length - 1 && ","}
                  </Typography>
                </div>
              );
          }
        })}
      </div>
    );
  };

  render() {
    const { classes, theme } = this.props;
    return (
      <div
        id="search-result"
        aria-label="Search result"
        style={{
          borderBottom: this.state.expanded ? "1px solid rgb(222,222,222)" : "",
          // display: this.props.mobile && "flex",
        }}
      >
        <div className={classes.wrapperDiv}>
          <div className={classes.centeredIcon}>
            <SearchResolution
              searchId={this.props.searchId}
              documentId={this.props.result.documentId}
              onResolution={this.props.onResolution}
              onUnResolved={this.props.onUnResolved}
              position={this.props.position}
              score={this.props.score}
              resolutions={this.props.resolutions}
            />
          </div>
          {this.props.previouslyResolved ? (
            <div tabindex={0} className={classes.centeredIcon}>
              <Tooltip
                title={
                  "Last linked to the same search " +
                  moment(this.props.lastResolvedDate).format(
                    "Do MMM YYYY HH:mm:ss"
                  )
                }
                enterDelay={300}
              >
                <div style={{ padding: "12px 0px" }}>
                  <svg style={{ width: 24, height: 24 }} viewBox="0 0 24 24">
                    <path
                      fill={theme.palette.secondary.main}
                      d={mdiLightbulbOnOutline}
                    />
                  </svg>
                </div>
              </Tooltip>
            </div>
          ) : (
            !this.props.mobile && <div style={{ padding: 12 }} />
          )}
          <ButtonBase
            focusRipple={false}
            disableRipple
            component="div"
            aria-expanded={this.state.expanded}
            onClick={() => {
              this.state.expanded
                ? this.props.history.goBack()
                : this.props.history.push(
                    `${this.props.history.location.pathname}/document/${
                      this.props.result.documentId
                    }`
                  );
              this.setState({ expanded: !this.state.expanded });
              // this.props.history.goBack();
            }}
            className={classnames(classes.accordionRoot, {
              [classes.focused]: this.state.focused,
              [classes.expanded]: this.state.expanded,
            })}
            id={`search-result-${this.props.result.documentId}-header`}
            aria-controls={`search-result-${
              this.props.result.documentId
            }-content`}
            onBlur={() => this.setState({ focused: false })}
            onFocusVisible={() => this.setState({ focused: true })}
            style={{
              justifyContent: "flex-start",
              paddingLeft: this.props.mobile && 0,
              width: this.props.mobile && 650,
            }}
          >
            <div style={!this.props.mobile ? {display:"flex", width: "100%"} : {}}>
              {this.props.mobile ?
                (<div style={!this.props.mobile ? { flex: "1 1 auto" } : {}}>
                  <Typography className={classes.heading}>
                    {this.props.result.title}
                  </Typography>
                </div>) : (
                  <Typography className={classes.heading}>
                    {this.props.result.title}
                  </Typography>
                )
              }
              {this.props.mobile ?
                (<div style={!this.props.mobile ? {display:"flex"} : {}}>
              {/* <Typography className={classes.secondaryHeading} style={{marginLeft: this.props.mobile && 0}}> */}
                  <Typography className={classes.secondaryHeadingMobile}>
                    {this.getSecondaryInfo()}
                  </Typography>
                </div>) : (
                <Typography className={classes.secondaryHeading}>
                  {this.getSecondaryInfo()}
                </Typography>
                )
              }
              {this.props.mobile &&
                <div
                  className={classes.score}
                  aria-label={`Result score: ${this.props.result.score}`}
                  // style={!this.props.mobile ? {display:"flex"} : {}}
                >
                  {this.getResultScore(this.props.result.score)}
                </div>
              }
            </div>
          </ButtonBase>
          {!this.props.mobile &&
                <div
                  className={classes.score}
                  aria-label={`Result score: ${this.props.result.score}`}
                  // style={!this.props.mobile ? {display:"flex"} : {}}
                >
                  {this.getResultScore(this.props.result.score)}
                </div>
          }
          <IconButton
              className={classnames(classes.expandIcon, {
                [classes.expanded]: this.state.expanded,
              })}
              edge="end"
              component="div"
              tabIndex={null}
              role={null}
              aria-hidden
              onClick={() => {
                this.state.expanded
                  ? this.props.history.goBack()
                  : this.props.history.push(
                      `${this.props.history.location.pathname}/document/${
                        this.props.result.documentId
                      }`
                    );
                this.setState({ expanded: !this.state.expanded });
                // this.props.history.goBack();
              }}
            >
              <ExpandMoreIcon />
          </IconButton>
          <div className={classes.centeredIcon}>
            <IconButton
              data-testid="document-result-user-list-button"
              onClick={this.addToUserList}
              className={classes.addToList}
              aria-label="Add document to a user list"
              id={`document-result-user-list-button-${
                this.props.result.documentId
              }`}
            >
              <AddIcon />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={this.state.menuAnchor}
              open={Boolean(this.state.menuAnchor)}
              onClose={this.handleMenuClose()}
            >
              <MenuItem disabled>
                <Trans i18nKey="add_to_user_list_list_header" />
              </MenuItem>
              {this.props.userLists.map((list, idx) => {
                return (
                  <MenuItem
                    selected={idx === 0}
                    key={idx}
                    onClick={this.handleMenuClose(list)}
                  >
                    {list.title}
                  </MenuItem>
                );
              })}
              <MenuItem
                id="search-create-new-user-list"
                onClick={this.handleMenuClose(null)}
              >
                <AddIcon /> New List
              </MenuItem>
              {/* <MenuItem onClick={this.addToLayout}>
                Add as document portlet
              </MenuItem> */}
            </Menu>
          </div>
        </div>
        <Collapse
          aria-labelledby={`search-result-${
            this.props.result.documentId
          }-header`}
          id={`search-result-${this.props.result.documentId}-content`}
          in={this.state.expanded}
          unmountOnExit={true}
          mountOnEnter={true}
          timeout={{ enter: 750, exit: 500 }}
        >
          {/* {this.state.resolutionId !== "" && <div style={{display : "block"}}>This document is linked to this Search</div>} */}
          <DocumentViewer
            id="search-result-document-viewer"
            searchId={this.props.searchId}
            documentId={this.props.result.documentId}
            fragments={this.props.result.fragments}
            filters={this.props.filters}
            isSearch
            searchString={this.state.searchString}
            isDraft={this.props.result.isDraft}
            position={this.props.position}
            resolutions={this.props.resolutions}
            score={this.props.score}
          />
        </Collapse>
        <Dialog
          open={this.state.newListDialogOpen}
          onClose={this.handleNewListDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Trans i18nKey="create_new_user_list_header" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Trans i18nKey="add_document_to_new_list_body" />
            </DialogContentText>
            <TextField
              id="search-create-new-user-list-title"
              label="List title"
              className={classes.textField}
              value={this.state.newListTitle}
              onChange={this.updateNewListTitle}
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNewListDialogClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              id="search-create-new-user-list-submit"
              onClick={this.handleNewListDialogSubmit}
              color="primary"
            >
              <Trans i18nKey="global_submit" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  // addToLayout = () => {
  //   let portlet = {};
  //   portlet.children = [];
  //   portlet.elementType = "CardDocument";
  //   portlet.icon = "chrome_reader_mode";
  //   portlet.isDefault = 1;
  //   portlet.isHidden = 0;
  //   portlet.isUser = 0;
  //   portlet.menuPortletId = 1142;
  //   portlet.objectClass = "";
  //   portlet.order = 0;
  //   portlet.isportlet = true;
  //   portlet.fullscreen = false;
  //   portlet.id = null;
  //   portlet.settingsExtended = null;
  //   portlet.settingsFullscreen = null;
  //   portlet.settingsList = null;
  //   portlet.instance = new Date().getTime();
  //   portlet.parameters = JSON.stringify({
  //     documentId: this.props.result.documentId,
  //   });
  //   portlet.title = this.props.result.title;
  //   axios
  //     .post(`/portalLayout/${this.props.portalLayout.id}/portlet/`, {
  //       ...portlet,
  //     })
  //     .then((res) => {
  //       PubSub.publish(PORTLET_LAYOUT_ADD, {
  //         layoutId: this.props.portalLayout.id,
  //         portletId: res.data.id,
  //       });
  //     });
  // };
  updateNewListTitle = (e) => {
    this.setState({ newListTitle: e.target.value });
  };

  handleNewListDialogClose = () => {
    this.setState({ newListDialogOpen: false });
  };

  handleNewListDialogSubmit = () => {
    this.props.createNewUserList(this.props.result, this.state.newListTitle);
    this.handleNewListDialogClose();
  };

  addToUserList = (e) => {
    e.stopPropagation();
    this.setState({ menuAnchor: e.currentTarget });
  };

  handleMenuClose = (list) => (e) => {
    e.stopPropagation();
    this.setState({ menuAnchor: null });
    if (list === undefined) {
      return;
    }
    if (list === null) {
      this.setState({ newListDialogOpen: true });
    } else {
      this.props.addResultToList(list, this.props.result);
    }
  };

  getResultScore = (score) => {
    let stars = [];
    let adjusted = Math.floor((score * 100) / 20);
    let remainder = (score * 100) / 20 - adjusted;
    let remainingStars = 5 - adjusted;
    var i = 0;
    for (i; i < adjusted; i++) {
      stars.push(<StarIcon key={i} />);
    }

    if (remainder > 0.24 && remainder < 0.76) {
      stars.push(<StarHalfIcon key={i++} />);
      remainingStars--;
    } else if (remainder >= 0.76) {
      stars.push(<StarIcon key={i++} />);
      remainingStars--;
    }

    for (let i = 0; i < remainingStars; i++) {
      stars.push(<StarBorderIcon key={i + 5} />);
    }
    return stars;
  };
}

const mapStateToProps = (state) => ({
  documentTypes: state.prefs.documentTypes,
  portalLayout: state.layout.currentLayout,
  mobile: state.screen.isMobile,
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(withTheme(withStyles(styles)(withLastLocation(SearchResult))))
);
